import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { QUALITY, QUALITY_ADD, QUALITY_DELETE } from "./actionTypes";
import {
	apiError,
	getQuality,
	qualityListSuccessful,
	qualityAddSuccessful,
} from "./actions";

// AUTH related methods
import {
	postAdd,
	getParamsList,
	postEdit,
	postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getQualities({ payload }) {
	var params = {};

	if (payload && typeof payload === 'object') {
		for (const k in payload) {
			if (Object.hasOwnProperty.call(payload, k)) {
				if (k === "currentSort" || k === "sortOrder") {
					params.ordering = payload.sortOrder + payload.currentSort;
				} else {
					if (payload[k] !== "") {
						params[k] = payload[k];
					}
				}
			}
		}
	}

	try {
		console.log("Quality API params being sent:", params);
		const response = yield call(getParamsList, "/masters/quality/", params);
		console.log("Quality API response:", response);
		yield put(qualityListSuccessful({ response, params: payload }));
	} catch (error) {
		console.error("Quality API error:", error);
		yield put(apiError(error));
	}
}
//If user is login then dispatch redux action's are directly from here.
function* AddQuality({ payload: { quality } }) {
	try {
		if (
			quality.id === 0 ||
			quality.id === undefined ||
			quality.id === null ||
			quality.id === ""
		) {
			const response = yield call(postAdd, "/masters/quality/", {
				name: quality.name,
			});
			if (response.status === 201) {
				swal("YourQuality Added Successfully.!", {
					icon: "success",
					timer: 1500,
				});
				yield put(getQuality());
			} else {
				swal("Sorry! Unable to add Quality. Please Try Again!", {
					icon: "error",
				});
			}
			yield put(qualityAddSuccessful(null));
		} else {
			const response = yield call(
				postEdit,
				"/masters/quality/" + quality.id,
				{
					code: quality.code,
					name: quality.name,
					modifiedon: new Date(quality.createdon),
				}
			);
			if (response.status === 200) {
				swal("Your Quality Edited Successfully.!", {
					icon: "success",
					timer: 1500,
				});
				yield put(getQuality());
			} else {
				swal("Sorry! Unable to edit Quality. Please Try Again!", {
					icon: "error",
				});
			}
			yield put(qualityAddSuccessful(null));
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});
		//yield put(apiError(error));
	}
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteQuality(qualityId) {
	try {
		const response = yield call(
			postDelete,
			"/masters/quality/" + qualityId.payload.qualityId
		);

		if (response.status === 204) {
			swal(" Your Quality has been deleted!", {
				icon: "success",
				timer: 1500,
			});
			yield put(getQuality());
		} else {
			swal("Sorry! Your Quality has been not deleted!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

export function* watchgetQuality() {
	yield takeEvery(QUALITY, getQualities);
}
export function* watchQualityAdd() {
	yield takeEvery(QUALITY_ADD, AddQuality);
}

export function* watchQualityDelete() {
	yield takeEvery(QUALITY_DELETE, DeleteQuality);
}

function* QualitySaga() {
	yield all([
		fork(watchgetQuality),
		fork(watchQualityAdd),
		fork(watchQualityDelete),
	]);
}

export default QualitySaga;
